import {
  enableProdMode,
  provideZoneChangeDetection,
  ErrorHandler,
  importProvidersFrom,
} from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { environment } from './environments/environment';
import './app/core/ag-grid/ag-grid-setup';

import 'hammerjs';
import { HttpInterceptors } from './app/core/interceptors';
import { MessageService } from 'primeng/api';
import { RavenErrorHandler } from './app/core/interceptors/raven.interceptor';
import { RouterlessTracking, Angulartics2Module } from 'angulartics2';
import {
  provideHttpClient,
  withXhr,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import {
  withPreloading,
  withRouterConfig,
  withComponentInputBinding,
  provideRouter,
  Routes,
  PreloadAllModules,
} from '@angular/router';

import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule } from '@angular/forms';
import { AccountModule } from './app/account/account.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgChartsModule } from 'ng2-charts';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AppComponent } from './app/app.component';
import CustomPrimeNgTheme from 'src/assets/theme/custom';

const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./app/landing/landing.component').then((m) => m.LandingComponent),
  },
  {
    path: 'login/callback',
    loadComponent: () =>
      import('./app/login/callback/login-callback.component').then(
        (m) => m.LoginCallbackComponent,
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./app/login/login/login.component').then((m) => m.LoginComponent),
  },
];

if (window.location.href.includes('login/callback')) {
  const accessToken = window.location.hash.split('#access_token=')[1];
  localStorage.setItem('access_token', accessToken);
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      NgSelectModule,
      NgxDatatableModule,
      FormsModule,
      AccountModule,
      BrowserAnimationsModule,
      NgChartsModule,
      AngularSvgIconModule.forRoot(),
      Angulartics2Module.forRoot(),
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    HttpInterceptors,
    MessageService,
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    { provide: ErrorHandler, useClass: RavenErrorHandler },
    RouterlessTracking,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        preset: CustomPrimeNgTheme,
        options: {
          // Currently we don't want our app to ever load in dark mode.
          // This is because we don't have a dark mode theme yet.
          // Once we have a dark mode theme, we can remove this selector.
          // To enable dark mode, add the class 'dark-mode-enabled' to the html element.
          darkModeSelector: '.dark-mode-enabled',
        },
      },
    }),
    provideRouter(
      appRoutes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
    ),
  ],
}).catch((err) => console.error(err));
